module.exports = __webpack_public_path__ + "static/media/image-37.88a88e71.png";